/// <reference types="./withUniqueNameAttempt.d.ts" />
import { ErrorType, notOk } from '@dossierhq/core';
const nameConflictErrorMessage = 'Name is not unique';
const maxAttempts = 10;
export async function withUniqueNameAttempt(context, name, randomNameGenerator, attempt) {
    let potentiallyModifiedName = name;
    for (let i = 0; i < maxAttempts; i += 1) {
        const attemptResult = await context.withTransaction(async (context) => {
            return await attempt(context, potentiallyModifiedName, nameConflictErrorMessage);
        });
        if (attemptResult.isOk()) {
            return attemptResult.map((it) => it);
        }
        if (attemptResult.isErrorType(ErrorType.Conflict) &&
            attemptResult.message === nameConflictErrorMessage) {
            potentiallyModifiedName = randomNameGenerator(name);
        }
        else {
            return attemptResult;
        }
    }
    return notOk.Generic(`Failed creating a unique name for ${name}`);
}
//# sourceMappingURL=withUniqueNameAttempt.js.map